<template>
    <div class="panel">
        <div class="container">
            <header>
                <span>
                    <b v-for="tab in tabs" :key="tab.name" @click="active=tab.name" :class="{active: tab.name === active}">
                        {{tab.title}}
                    </b>
                </span>
            </header>
            <div>
                <login v-for="tab in tabs" :key="tab.name" :type="tab.name" v-show="active === tab.name"></login>
            </div>
        </div>
    </div>
</template>

<script>
    import Login from "./login";
    export default {
        name: "mainView",
        components: {Login},
        data() {
            return {
                tabs: [
                    {
                        name: 'login',
                        title: '登录',
                    },
                    {
                        name: 'register',
                        title: '注册',
                    },
                ],
                active: 'login',
            }
        }
    }
</script>

<style scoped lang="scss">
@import "../styles/element-variables";
.panel {
    height: 100%;
    width: 100%;
    background-size: 100% 100%;
    background-image: url('../assets/img/pc/background.png');
    @media screen and (max-width: $--media-max-width){
        background-image: url('../assets/img/h5/background.png');
    }
}
.container {
    width: 840px;
    height: 760px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    background-color: white;
    border-radius: 25px;
    box-shadow: 0 3px 13px 0 rgba(133, 130, 184, 0.48);
    text-align: center;
    font-size: 22px;
    color: #9f9ed2;
    @media screen and (max-width: $--media-max-width){
        width: 2.1333rem;
        height: 3.5rem;
        border-radius: 0.1333rem;
    }
    header {
        font-size: 32px;
        display: inline-block;
        text-align: center;
        position: relative;
        margin-top: 45px;

        @media screen and (max-width: $--media-max-width){
            margin-top: 0.1533rem;
            font-size: 0.14rem;
        }
        span {
            width: 480px;
            display: flex;
            justify-content: space-around;
            @media screen and (max-width: $--media-max-width){
                width: 1.3rem;
            }
        }
        b {
            color: #adaae3;
            cursor: pointer;
        }
        b.active, b:hover {
            color: #8b73cc;
        }
    }
}
</style>
